<template>
  <div id="home">
    <!-- 导航条 -->
    <div v-if="toTop < 200">
    <nav class="navbar navbar-default navbar-fixed-top" ref="btn" id="Nav">
        
      <!-- We use the fluid option here to avoid overriding the fixed width of a normal container within the narrow content columns. -->
      <div class="container-fluid">
        <div class="navbar-header">
          <img :src="HomeLogo" class="nav_image">
        </div>

        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-6">
          <ul class="nav navbar-nav nav_ul" >
            <li class="active" id="active_li" v-for="(target,id) in navList" :key="id" @click="choseprofrom(id)"  >
                <!-- {{target.name}} -->
                <router-link :class="{'secectBackground':flag==id}" :to="target.ur">{{target.name}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </div>

    <div v-if="toTop >= 200">
    <nav class="navbar navbar-default navbar-fixed-top nav_toTop" ref="btn" id="Nav">
        
      <!-- We use the fluid option here to avoid overriding the fixed width of a normal container within the narrow content columns. -->
      <div class="container-fluid">
        <div class="navbar-header">
          <img :src="webLogo" class="nav_image">
        </div>

        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-6">
          <ul class="nav navbar-nav nav_ul" >
            <li class="active" id="con_li" v-for="(target,id) in navList" :key="id" @click="choseprofrom(id)"  >
                <!-- {{target.name}} -->
                <router-link :class="{'secectBackground':flag==id}" :to="target.ur">{{target.name}}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </div>
    
    <div class="container-fluid">
        <div class="row container_row">
            <div class="col-lg-12 topImg">
                <img :src="HomeTopImg"  class="topImage"  id="topImage">
            </div>
            <div class="col-lg-12 backGrund">
                <span class="product">COMPANY PRODUCTS</span>
                <span class="product1">公司产品</span>
                <img :src="HomeBackground" class="backoundImage">
                <div class="col-lg-12  Wheel_Planting_image">
                    <!-- pc端轮播图 -->
                    <div v-if="screenWidth > 750"> 
                        <div class="webMian">
                            <i class="icon iconfont icon07jiantouxiangzuo" @click="leftSlide"></i>
                            <div class="webMian_content" v-for="(da,data) in webProductList" v-if="pindex == data" :key="data" >
                                <div class="content_cont" v-for="(value,key) in da" :key="key">
                                    <img :src="value.imagS" class="cont_image">
                                    <span class="cont_title">{{value.title}}</span>
                                    <p class="cont_content">{{value.cont}}</p>
                                    <span class="see_Btn" @click="seeDetails(key,value.id)">查看详细</span>
                                </div>
                                <!-- 轮播图下标 -->
                                <ul class="dots">  
                                    <li v-for="(dot, i) in webProductList" :key="i" :class="{dotted: i ==pindex }" @click="slideAuto(i)" ></li>
                                </ul>
                            </div>
                            <i class="icon iconfont icon07jiantouxiangyou" @click="rightSlide"></i>
                        </div>
                    </div> 
                    <!-- 移动端滑块 -->
                    <div v-if="screenWidth < 750"> 
                        <div class="Product_Ul">
                            <swiper ref="swiper-container" :options="swiperOption">
                                <swiper-slide class="swiper-slide" v-for="(item,key) in productsList" :key="key" >
                                    <div class="swiper_div" @click="appDetails(key,item.id)">
                                        <img  :src="item.imagS" class="slider_conts_image" >
                                        <span class="slider_conts_title" >{{item.title}}</span>
                                        <p class="slider_conts_content">{{item.cont}}</p>
                                    </div>
                                </swiper-slide>
                            </swiper>
                        </div>
                    </div> 
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12  newS">
                <span class="product pro_duct">COOPERATIVE NEWS</span>
                <span class="product1">公司动态</span>
                <div class="row New">
                    <div class="col-md-6 new_cont" v-for="(item,index) in dynamicList" :key="index" @click="seeDynamicDetails(item.id)">
                        <span class="new_title">{{item.title}}</span>
                        <img :src="item.thumb" class="New_image">
                        <p class="new_content">{{item.description}}</p>
                    </div>
                    <div class="col-md-12 View_More">
                        <button class="View_More_Btn" @click="MoreDynamic">查看更多</button>
                    </div>
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 bcak_Consultation">
                <img :src="HomeConsultation" class="Consultation_image">
                <span class="consultation">COOPERATIVE CONSULTATION</span>
                <span class="consultation1">合作咨询</span>
                <div class="row consultation_form">   
                   <form action="" @submit.prevent="submit">   
                    <div class="col-md-6 form_Control_sele">
                       
                        <form>
                            <select class="form-control form_Control sele_Control" ref="addRequestBusiness" @change="showValueBusiness()">
                                <!-- <option >{{Business}}</option> -->
                                <option v-for="item in businessList" :key="item.value" :label="item.label" :value="item.label"></option>
                            </select>
                        </form>
                        <form>
                            <select class="form-control form_Control sele_Control" ref="addRequestProduct" @change="showValueProduct()">
                                 <!-- <option >{{Product}}</option> -->
                                <option v-for="item in productList" :key="item.value" :label="item.label" :value="item.label"></option>
                            </select>
                        </form>
                        <input type="text" class="form-control form_Control" id="exampleInputName1" placeholder="姓名" v-model="iputName">
                        <input type="text" class="form-control form_Control" id="exampleInputName2" placeholder="公司" v-model="iputCompany">
                        <div class="formPhone" v-if="screenWidth > 750">
                            <input type="text" class="form-control form_Control form_Phone" id="exampleInputName3" placeholder="电话" ref="Phone" v-model="iputPhone">
                            <input type="text" class="form-control form_Control form_Phone_Code" maxlength="6" id="exampleInputName4" placeholder="请输入验证码" v-model="iputCode">
                            <input class="Obtain_Code" type="button" :value="btnContent" @click="wObtainCode()" v-bind="{'disabled':disabled}">
                        </div>
                        <div v-if="screenWidth < 750">
                            <input type="text" class="form-control form_Control form_Phone" id="exampleInputName5" placeholder="电话" v-model="iputPhone">
                        </div>
                        <div class="formPhone" v-if="screenWidth < 750">
                            <input type="text" class="form-control form_Control form_Phone_Code" maxlength="6" id="exampleInputName6" placeholder="请输入验证码" v-model="iputCode">
                            <input class="Obtain_Code" type="button" :value="btnContent" @click="wObtainCode()" v-bind="{'disabled':disabled}">
                        </div>

                        
                        <div v-if="screenWidth > 750">
                            <span class="sp_emai" style="color: #ffff;">或者您发送咨询邮件至service@qisuxinxi.com</span>
                        </div>
                    </div>
                    <div class="col-md-6 text_Input">
                        <textarea class="form-control textInput"  placeholder="您好，请填写你所需要咨询的内容。" v-model="iputContent" ></textarea>
                        <div v-if="screenWidth < 750">
                            <span class="sp_emai" style="color: #ffff;">或者您发送咨询邮件至service@qisuxinxi.com</span>
                        </div>
                        <button class="submBtn">提交</button>
                    </div>
                   </form> 
                </div>
            </div>
        </div>
         <ReturnTop/>
         <HeadTail/>
    </div>
  </div>
</template>

<script>
import headTail from './publicComponent/HeadTail'
import returnTop from './publicComponent/ReturnTop'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide ,swiperWrapper} from 'vue-awesome-swiper'
export default {
  data(){
      return{
          toTop:0,
          pindex:0,
          webProductList:[],
          navList:[
              {name:"首页",id:0,ur:'/'},
              {name:"公司简介",id:1,ur:'/CompanyProfile'},
              {name:"公司产品",id:2,ur:'/CompanyProducts'},
              {name:"公司动态",id:3,ur:'/Dynamic'},
            //   {name:"合作伙伴",id:4,ur:'/CooperativePartner'},
              {name:"联系我们",id:4,ur:'/ContactUs'},
          ],
        //   flag: -1,
          webLogo: '../../static/image/webLogo.png',
          screenWidth: document.body.clientWidth,
          webProduct:
            {  webProductOne:"../../static/image/homeImage/webProduct1.png",
               webProductTwo:"../../static/image/homeImage/webProduct2.png",
               webProductThree:"../../static/image/homeImage/webProduct3.png"
            },
          appProduct:
            {  appProductOne:"../../static/image/homeImage/appProduct1.png",
               appProductTwo:"../../static/image/homeImage/appProduct2.png",
               appProductThree:"../../static/image/homeImage/appProduct3.png"
            }, 
		   _imgSrc: [
			   '../../../static/image/homeImage/webNew1.png',
			   '../../../static/image/homeImage/webNew2.png',
			   '../../../static/image/homeImage/webNew1.png',
			   '../../../static/image/homeImage/webNew2.png',
			   '../../../static/image/homeImage/webNew1.png',
			   '../../../static/image/homeImage/webNew1.png',
			   '../../../static/image/homeImage/webNew2.png',
			   '../../../static/image/homeImage/webNew1.png',
			   '../../../static/image/homeImage/webNew2.png',
			   '../../../static/image/homeImage/webNew1.png',
		   ],
		//    get imgSrc() {
		// 	   return this._imgSrc;
		//    },
		//    set imgSrc(value) {
		// 	   this._imgSrc=value;
		//    },
            startPointX: 0,
            changePointX: 0,
            showIndex: 0,
            margLeft:null,  
            webMianList:[
                {title:"掌上青囊",id:0,imagS:'../../static/image/homeImage/webProduct1.png',cont:"上海岐素信息科技有限公司与静安卫计委合作研发的一款微信小程序，包括知识学堂、趣味练习、试题考核、错题集锦四大板块，用以提供社区医师、社区护理员及普通用户三类人群中医药专业知识在线学习并考核的知识学习平台。"},
                {title:"杏林智医",id:1,imagS:'../../static/image/homeImage/webProduct2.png',cont:"上海岐素信息科技有限公司为上海静安区卫生机构专门研发的一款微信小程序，展示社区机构及社区医师简介，以文章、视频、音频、在线智能中医辨证等形式为社区居民提供中医药智慧健康服务。"},
                {title:"书香识芳草",id:2,imagS:'../../static/image/homeImage/webProduct3.png',cont:"上海岐素信息科技公司研发的一款微信小程序，旨在中国经典古诗词中挖掘中医药文化相关知识，以答题闯关、收集卡片、集成图鉴形式传播中医药文化及中华传统文化，让孩子在趣味学习中增长中医药知识，辅助家长教学。"},
                {title:"中医药文化传播终端",id:3,imagS:'../../static/image/homeImage/webProduct4s.png',cont:"上海岐素信息科技有限公司基于互联网人工智能技术和软件控制技术推出的中医药文化传播高端产品，用于中医药知识文化宣传及静安社区机构的活动动态展示。"},
               
            ],
            productsList:[
                {title:"掌上青囊",id:0,imagS:'../../static/image/homeImage/appProduct1.png',cont:"上海岐素信息科技有限公司与静安卫计委合作研发的一款微信小程序，包括知识学堂、趣味练习、试题考核、错题集锦四大板块，用以提供社区医师、社区护理员及普通用户三类人群中医药专业知识在线学习并考核的知识学习平台。"},
                {title:"杏林智医",id:1,imagS:'../../static/image/homeImage/appProduct2.png',cont:"上海岐素信息科技有限公司为上海静安区卫生机构专门研发的一款微信小程序，展示社区机构及社区医师简介，以文章、视频、音频、在线智能中医辨证等形式为社区居民提供中医药智慧健康服务。"},
                {title:"书香识芳草",id:2,imagS:'../../static/image/homeImage/appProduct3.png',cont:"上海岐素信息科技公司研发的一款微信小程序，旨在中国经典古诗词中挖掘中医药文化相关知识，以答题闯关、收集卡片、集成图鉴形式传播中医药文化及中华传统文化，让孩子在趣味学习中增长中医药知识，辅助家长教学。"},
                {title:"中医药文化传播终端",id:3,imagS:'../../static/image/homeImage/appProduct4.png',cont:"上海岐素信息科技有限公司基于互联网人工智能技术和软件控制技术推出的中医药文化传播高端产品，用于中医药知识文化宣传及静安社区机构的活动动态展示。"},
            ],
            qid:null,
            // currentIndex: 0,
            dynamicList:[],
            swiperOption:{},
            iputName:"",
            iputCompany:"",
            iputPhone:"",
            iputCode:"",
            iputContent:"",
            disabled:false,
            time:0, //发送验证码间隔时间]
            btnContent:"获取验证码", //获取验证码按钮内文字
            // Business:"请选择您所处的行业",
            // Product:"请选择您合作的业务",
            businessList:[{
                id: 0,
                label: '请选择您所处的行业'
                },{
                id: 1,
                label: '食品生成企业'
                }, {
                id: 2,
                label: '食品流通企业'
                }, {
                id: 3,
                label: '中医医疗机构'
                }, {
                id: 4,
                label: '体验机构'
                }, {
                id: 5,
                label: '健康服务机构'
            }, {
                id: 6,
                label: '其他'
            }],
            productList:[{
                id: 0,
                label: '请选择您合作的业务'
                },{
                id: 1,   
                label: '产品合作'
                }, {
                id: 2,    
                label: '线下健康服务'
                }, {
                id: 3,     
                label: '活动宣传'
                }, {
                id: 4,    
                label: '广告业务'
                }],
      }
  },
  computed: {
      swiper() {
        return this.$refs.content_text_div.swiper
      }
  },
  created(){
     if(document.body.clientWidth > 750){
        this.HomeTopImg='../../static/image/homeImage/websiteHome.png'
        this.HomeBackground = '../../static/image/homeImage/webBackground.png'
        this.HomeConsultation = '../../static/image/homeImage/webConsultation.png'
        this.HomeLogo = '../../static/image/NavLogo.png'
     }else  {
        this.HomeTopImg='../../static/image/homeImage/appHomeImg.png'
        this.HomeBackground = '../../static/image/homeImage/appBackground.png'
        this.HomeConsultation = '../../static/image/homeImage/appConsultation.png'
        this.HomeLogo = '../../static/image/appLogo.png'
        this.navList.splice(4,1)
     }
     let thct=this;
     thct.swiperOption={
      slidesPerView: 2,
      spaceBetween: 30,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },  
    }
     this.flag = 0
     this.getList()
     this.$http.get('https://api.hanfangyiyang.cn/cms/articles',{params:{cid: 17}}).then(response => {
        var dynamicList = response.data.data
        this.dynamicList = dynamicList.slice(0,4);
        // console.log(dynamicList.slice(0,4))
      });

  },
  mounted(){
    window.addEventListener('scroll', this.scrollToTop)
    
  },
  methods:{
    choseprofrom:function (id) {
        this.flag = id;
    },
    scrollToTop() { 
　　    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
　　    this.toTop = scrollTop 
    },
    // 左滑
    leftSlide(){
        if(this.pindex == 0){

        }else{
            this.pindex = this.pindex-1
        }
    },
    // 右滑
    rightSlide(){
        if(this.webProductList.length-1 ==this.pindex){
            
        }else{
            this.pindex = this.pindex+1 
        }
    },
    // 点击圆点切换轮播图
    slideAuto(inde){
        this.pindex=inde;
    },
    // 查看详情
    seeDetails(indx,qid){
        // qid = indx
        this.$router.push({name:"CompanyProducts",query:{qid:qid}})
    },
    // 移动端查看详情
    appDetails(indx,qid){
        // qid = indx
        this.$router.push({name:"CompanyProducts",query:{qid:qid}})
    },
    getList(){
        var result = [],
        b = [],
        k = 0 
        for(var i = 0; i < this.webMianList.length; i++){
            if(i % 3 == 0){
                b = []
                for(var j = 0;j<3;j++){
                    if(this.webMianList[i + j] == undefined){
                        continue;
                    }else{
                        b[j] =this.webMianList[i+j]
                    }
                }
                result[k] = b
                k++;
            }
        }
        this.webProductList = result
        // console.log(this.webProductList)
    },
    //查看动态详情
    seeDynamicDetails(aid){
        this.$router.push({  //核心语句
            path:'/Detailstest',   //跳转的路径
            query:{           //路由传参时push和query搭配使用 ，作用时传递参数
                aid:aid, 
            }
        })
    },
    show(index){
      this.changePointX=this.startPointX;
      let slider = document.getElementById('slider');
      this.margLeft  = `-${60*index}px !important`;
    },
    touchstart(e){
      this.startPointX = e.changedTouches[0].pageX;
    },
    touchmove(e){
      if(this.startPointX==this.changePointX){
        return ;
      }
      let currPointX = e.changedTouches[0].pageX;
      let leftSlide = this.startPointX-currPointX;
      if(leftSlide>30&&this.showIndex<this.productList.length-1){
        this.show(++this.showIndex)
      }else if(leftSlide<-30&&this.showIndex>0){
        this.show(--this.showIndex)
      }
    },
    MoreDynamic(){
        this.$router.push({  //核心语句
            path:'/Dynamic',   //跳转的路径
        })
    },
    showValueBusiness(){
        this.business = this.$refs.addRequestBusiness.value
        console.log(this.$refs.addRequestBusiness.value)
    },
    showValueProduct(){
        this.Product = this.$refs.addRequestProduct.value
    },
    
    submit(){

        if(this.$refs.addRequestBusiness.value == "请选择您所处的行业"){
            alert('请选择您所处的行业')
            return false
        }
        if(this.$refs.addRequestProduct.value == "请选择您合作的业务"){
            alert("请选择您合作的业务")
            return false
        }
        var regName = /^[\u4e00-\u9fa5]{2,4}$/;
        if(this.iputName == "" ){
            alert("姓名不能为空！")
            return false
        }else if(!regName.test(this.iputName)){
            alert("姓名格式错误！")
            this.iputName = ""
            return false
        }
        if(this.iputCompany == ""){
            alert("公司名称不能为空！")
            return false
        }else if(!regName.test(this.iputCompany)){
            alert("公司名称格式错误！")
            this.iputCompany = ""
            return false
        }
        if(this.iputCode == ""){
            alert("验证码不能为空！")
            return false
        }
        if(this.iputContent == ""){
            alert("内容不能为空！")
            return false
        }

        
        this.$http.post('https://api.hanfangyiyang.cn/web/cooperation',{
            territory:this.business,
            business:this.Product,
            customer_name:this.iputName,
            customer_company:this.iputCompany,
            customer_phone:this.iputPhone,
            consultation: this.iputContent,
            verify:this.iputCode
        }).then(response => {
            console.log(response)
        });
       
    },
    wObtainCode(){
        
        var regPhone=11&& /^((13|14|15|17|18)[0-9]{1}\d{8})$/;//手机号正则验证
        if(!this.iputPhone){
            alert("手机号不能为空")
        }else if(!regPhone.test(this.iputPhone)){//手机号不合法
            alert("您输入的手机号码不合法，请重新输入");
        }else{
            this.time = 60;
            this.$http.post('https://api.hanfangyiyang.cn/web/sms',{phone:this.iputPhone,type:1}).then(response => {
                this.iputCode = response.data.data[0].msgCode
                this.timer();
            });
        }
    },
    timer(){
        if(this.time>0){
         this.time--;
         this.btnContent = this.time+" ";
         this.disabled = true;
         var timer = setTimeout(this.timer,1000);
        }else if(this.time == 0){
         this.btnContent = "获取验证码";
         clearTimeout(timer);
         this.disabled = false;
        }
    },
  },
  components: {
        'HeadTail': headTail,  
        "ReturnTop" : returnTop,
        swiper,
        swiperSlide,
        swiperWrapper, 
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* PC端特殊样式 */
@media screen and (min-width: 750px){
    /* 头部 */
    .navbar-default .navbar-nav>.active>a, .navbar-default .navbar-nav>.active>a:focus, .navbar-default .navbar-nav>.active>a:hover{
        background-color: transparent;
        border-radius: 10vw;
        color: #fff ;
        padding: 5px 10px 5px 10px !important;
    }
    .navbar-nav{
        clear: both;
    }
    .navbar{
        background: none !important;
        border: none;
    }
    .nav_toTop{
        background: #fff !important;
        /* color: #000; */
        border-bottom: 1px solid #dcdbdd;
    }
    #con_li>a{
        color: #000;
    }
    /* logo */
    .nav_image{
        margin: 1.5vh 0 2vh 18vw !important;
    }
    .nav_ul{
        /* padding-left: 15vw !important;
        padding-top: 3.5vh !important; */
        position: absolute;
        left: 43%;
        top: 41%;
        
    }

    .secectBackground{
        color: #008aef !important;
        background: #fff !important;
    }

    .nav_ul>li{
        text-align: center;
        font-size: 11pt;
        font-weight: 550;
        color: #fff;
        border-radius: 10vw;
        margin: 0 0 0 2vw !important;
    }
    /* 头部图片 */
    .topImage{
        width: 100%;
    }
    .backoundImage{
        width: 100%;
    }
    .Consultation_image{
        width: 100%;
        min-height: 778px;
    }
    .product{
        color: #aed9ef;
        font-size: 1.5vw;
        font-weight: 600;
        position: absolute;
        top: 6vh;
        left: 42vw;
    }
    .pro_duct{
       color: #e6e6e6; 
    }
    .product1{
        color: #0047ab;
        font-size: 1.5vw;
        font-weight: 600;
        z-index: 10;
        position: absolute;
        left: 46.5vw;
        top: 6vh;
    }
    .consultation{
        color: #58a6f2;
        font-size: 1.5vw;
        font-weight: 600;
        position: absolute;
        top: 10vw;
        left: 39vw;
    }
    .consultation1{
        color: #fff;
        font-size: 1.5vw;
        font-weight: 600;
        z-index: 10;
        position: absolute;
        left: 46.5vw;
        top: 10vw;
    }
    .Wheel_Planting_image{
        /* border: 1px solid; */
        width: 100%;
        height: 30vw;
        position: absolute;
        top: 15vh;
        /* left: 7.8vw; */
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        justify-content: center;
    }
    /* 行业动态 */
    /* .newS{
        
        border: 1px solid;
    } */
    .New_image{
        width: 29.3vw;
        height: 45vh;
    }
    .New{
        margin-top: 10% !important;
        display: flex;
        flex-wrap: wrap;
        padding-left: 15vw !important;
        padding-right: 15vw !important;
    }
    .new_title{
        font-size: 0.8vw;
        font-weight: 600;
        margin-bottom: 1% !important;
    }
    .new_cont{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 5% !important;
    }
    .new_content{  
        padding-left: 2.5vw !important;
        padding-right: 2.5vw !important;
        margin-top: 1% !important;
        display: -webkit-box;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .View_More{
        display: flex;
        justify-content: center;
    }
    .View_More_Btn{
        width: 5vw;
        height: 4vh;
        background: none;
        border: 1px solid #0e7be9;
        border-radius: 5vw;
        color: #65abf3;
        font-size: 0.5vw;
        line-height: 4vh;
    }
    /* 合作咨询 */
    .consultation_form{
        position: absolute;
        top: 40%;
        width: 100%;
        /* border: 1px solid; */
        padding-left: 11% !important;
    }
    .form_Control_sele{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .form_Control{
        width: 30vw !important;
        min-height: 2.5vw !important;
        padding-left: 2% !important;
        /* margin-left: 25% !important; */
        margin-bottom: 3% !important;
    }
    .text_Input{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-right: 22% !important;
    }
    .submBtn{
        width: 6vw;
        height: 2vw;
        background: #fff;
        color: #008aef;
        border-radius: 15vw;
        border: none;
        font-size: 0.9vw;
        font-weight: 600;
        /* margin-left: 35% !important; */
        display: block;
        margin-top: 2% !important; 
        outline: none;
    }
    .textInput{
        width: 35vw  !important;
        resize: none;
        padding-left: 2% !important;
        padding-right: 2% !important;
        padding-top: 1% !important;
        font-size: 0.9vw !important;
        height: 17vw  !important;
         overflow: auto;
        word-break: break-all; 
        resize:none;
    }
    /* pc端轮播图 */
    .webMian{
        width: 80vw;
        /* border: 1px solid; */
        height: 56vh;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .webMian_content{
        width: 100%;
        /* border: 1px solid red; */
        height: 56vh;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 100px 0 100px !important;
    }
    .icon{
        color: #787f9b;
        font-size: 2.2vw !important;
    }
    .icon:active{
        color: #00a6ff;
        cursor:pointer;
    }
    .content_cont{
        width: 17.2vw;
        height: 38vh;
        /* border: 1px solid chartreuse;  */
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: column;
        background: #fff;
        border-radius: 10px;
        /* margin-left: 5vw !important; */
        transition:All 0.6s ease-in-out;
        box-shadow: inset 0px 0px 2px #a3becc;
        overflow: hidden;
    }
    .cont_image{
        width: 7.4vw;
        margin-top: 5% !important;
    }
    .cont_title{
        padding-top: 2vh !important;
        font-size: 1.1vw;
        font-weight: 600;
    }
    .cont_content{
        padding-top: 12% !important;
        padding-left: 4% !important;
        padding-right: 4% !important;
        font-size: 0.7vw;
        color: #333333;
        display: -webkit-box;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
    .see_Btn{
        /* width: 4vw;
        height: 3vh; */
        border: 1px solid #fff;
        border-radius: 20vw;
        text-align: center;
        line-height: 3vh;
        color: #fff;
        display: none;
        padding: 5px 12px 5px 12px !important;
    }
    .dots{
        position:absolute;
        bottom:0;
        left:50%;
        /* transform:translateX(-50%); */
    }
    .dots li{
        display:inline-block;
        width:12px;
        height:12px;
        margin:0 5px !important; 
        border:1px solid #8291b7;
        border-radius:50%;
        /* background-color:#008ff0; */
        cursor:pointer;
    }
    .dots .dotted{
        background-color:#008ff0;
    }
    .content_cont:hover{
        background: #00a6ff;
        transform: translate(0,-5%);
        
    }
    .content_cont:hover .cont_image{
        display: none;
    }
    .content_cont:hover .cont_title{
        margin-top: 15% !important;
        color: #fff;
    }
    .content_cont:hover .cont_content{
        color: #fff;
    }
    .content_cont:hover .see_Btn{
        display: block;
        margin-top: 10% !important;
        cursor:pointer;
    }
    .sp_emai{
        position: absolute;
        left: 7vw;
    }
    .form_Phone{
        width:15vw !important;
    }
    .form_Phone_Code{
        width:6vw !important;
        font-size: 0.1em;
    }
    .Obtain_Code{
        width:6vw !important;
        height: 2.5vw !important;
        background: #fff;
        color: #0079eb;
        text-align: center;
        line-height: 2.5vw !important;
        border: 0;
    }
    .formPhone{
        width: 30vw !important;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
   
}
/* 移动端特殊样式 */
@media screen and (max-width: 750px){
    .navbar-default .navbar-nav>.active>a, .navbar-default .navbar-nav>.active>a:focus, .navbar-default .navbar-nav>.active>a:hover{
        background-color: transparent;
        /* color: #008cef ;  */
        height: 5vh;
    }
    /* .container-fluid>.navbar-collapse, .container-fluid>.navbar-header, .container>.navbar-collapse, .container>.navbar-header{
        display: flex;
        justify-content: center;
    } */
    .navbar-fixed-bottom, .navbar-fixed-top{
        position: relative;
    }
    .navbar{
        background: none !important;
        width: 100%;
    }
    .navbar-default .navbar-collapse, .navbar-default .navbar-form{
        border: none;
    }
    .collapse{
        display: block;
    }
    .nav_ul{
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        margin-top: 4% !important;
        box-shadow: 0 6px 5px rgba(64, 64, 64, 0.1);
    }
    .nav_ul>li{
        display: inline-block;
        width: 26%;
        text-align: center;
        /* font-size: 4.2vw; */
        font-size: 12pt;
        
    }
    .secectBackground{
        border-bottom: 1px solid #008cef;
        color: #008cef !important;
    }
    /* logo */
    .nav_image{
        margin-left: 25vw !important;
        width: 52%;
        margin-top: 5vw !important;
    }
    .topImage{
        width: 100%;
        margin-top: 15%;
    }
    .backoundImage{
        width: 100%;
        touch-action: none;
    }
    .Consultation_image{
        width: 100%;
    }
    .product{
        color: #aed9ef;
        font-size: 4vw;
        font-weight: 600;
        position: absolute;
        top: 20px;
        left: 30vw;
    }
    .pro_duct{
       color: #e6e6e6; 
    }
    .product1{
        color: #0047ab;
        font-size: 4vw;
        font-weight: 600;
        z-index: 10;
        position: absolute;
        left: 44vw;
        top: 19.5px;
    }
    .Wheel_Planting_image{
        width: 100%;
        position: absolute;
        top: 48px;
        display: flex;
        flex-wrap: nowrap;
        overflow: hidden;
    }
    /* 产品轮播图滑块 */
    .slider_conts{
        width: 42.5vw;
        height: 27vh;
        /* border: 1px solid; */
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: column;
        background: #fff;
        border-radius: 10px;
        margin-right: 2% !important;
        /* box-shadow: 0px 0px 5px #000; */
        box-shadow: inset 0px 0px 2px #a3becc;
    }
    .slider_conts_image{
        width: 35%;
        /* height: 15vw; */
        margin-top: 10px !important;
    }
    .slider_conts_title{
        margin-top: 4px !important;
        font-size: 11pt;
        font-weight: 800;
    }
    .slider_conts_content{
        padding-top: 22px !important;
        padding-left: 2vw !important;
        padding-right: 2vw !important;
        font-size: 1.2rem;
        color: #333333;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        overflow: hidden;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
    }
    /* 新闻图片 */
    .New_image{
        width: 100%;
    }
    .New{
        margin-top: 15% !important;
    }
    .new_title{
        font-size: 11pt;
        font-weight: 700;
        margin-bottom: 1% !important;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
    }
    .new_cont{
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 8% !important;
        margin-left: 3% !important;
        margin-right: 3% !important;
    }
    .new_content{  
        margin-top: 1% !important;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
    }
    .View_More{
        display: flex;
        justify-content: center;
    }
    .View_More_Btn{
        width: 20vw;
        height: 5vh;
        background: none;
        border: 1px solid #0e7be9;
        /* border-image: linear-gradient(to right, #0e7be9, #21b1f7); */
         /* border-image: linear-gradient(#0e7be9,#21b1f7) 30 30; */
         border-radius: 5vw;
         color: #65abf3;
         /* font-size: 0.5vw; */
    }
    .consultation{
        color: #58a6f2;
        font-size: 4vw;
        font-weight: 600;
        position: absolute;
        top: 10vw;
        left: 22vw;
    }
    .consultation1{
        color: #fff;
        font-size: 4vw;
        font-weight: 600;
        z-index: 10;
        position: absolute;
        left: 42.5vw;
        top: 10vw;
    }
    /* form表单 */
    .consultation_form{
        position: absolute;
        top: 14%;
        width: 100%;
        /* border: 1px solid; */
    }
    .form_Control_sele{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .form_Control{
        width: 90vw !important;
        min-height: 12vw !important;
        padding-left: 2% !important;
        margin-bottom: 2% !important;
    }
    .sele_Control{
        width: 90vw !important;
        height: 50px !important;
        padding-left: 5% !important;
        margin-bottom: 2% !important;
        /* -webkit-appearance: none; */
        /* -webkit-appearance: */
    }
    .text_Input{
        display: flex;
        flex-direction: column;
        align-items: center;
       
    }
    .textInput{
        width: 90vw !important;
        min-height: 42vw !important;
        padding-left: 2% !important;
        padding-right: 2% !important;
        margin-bottom: 2% !important;
        padding-top: 2% !important;
        resize:none;
    }
    .submBtn{
        width: 21vw;
        height: 7vw;
        background: #fff;
        color: #008aef;
        border-radius: 15vw;
        border: none;
        /* font-size: 0.9vw; */
        /* font-weight: 600; */
        /* margin-left: 35% !important; */
        display: block;
        margin-top: 8% !important; 
        outline: none;
    }
    .sp_emai{
        position: absolute;
        bottom: 5vh;
        left: 22px;
        color: #fff;
    }
    .slider_conts{
        width: 42.5vw;
        height: 14vh;
        /* border: 1px solid; */
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: column;
        background: #fff;
        border-radius: 10px;
        margin-right: 2% !important;
    }

    .swiper-container {
      width: 100%;
      height: 220px;
      /* margin: 20px auto !important; */
    }
    .swiper-slide {
      text-align: center;
      font-size: 18px;
      background: #fff;
      width: 40% !important;
      height: 188px;
      /* Center slide text vertically */
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      margin: 12px !important;
      border-radius: 10px;
      box-shadow: inset 0px 0px 2px #a3becc;
      
    }
    .swiper_div{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }
    .swiper-pagination{
        bottom: 5%;
        /* left: 50%; */
        width: 100%;
    }

    .form_Phone_Code{
        width:60vw !important;
        
    }
    .Obtain_Code{
        width:25vw !important;
        height: 12vw !important;
        background: #fff;
        color: #0079eb;
        text-align: center;
        line-height: 12vw !important;
        /* cursor:pointer; */
        border: 0;
    }
    .formPhone{
        width: 90vw !important;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    
}

.topImg{
    background: #d1efff;
}
/* 公司产品 */
.backGrund{
    position: relative;
}
.carousel-control{
    opacity: 1 !important;
}
.bcak_Consultation{
    position: relative;
}
.form-control{
    border-radius: 0 !important;
}
/* 产品logo */

</style>



// WEBPACK FOOTER //
// src/components/Home.vue